<!-- <div class="fixed-top">
        <div class="d-flex flex-column">
            <app-header #header></app-header>
            <app-breadcrumb></app-breadcrumb>
        </div>
    </div> -->
  <div id="backset" style="height:45px;"></div>
  <!-- <nav aria-label="breadcrumb" *ngIf="employeeData">
        <ol class="breadcrumb mb-0">
            <li class="breadcrumb-item active" (click)= "switchDeckView()">MockUps</li>
            <li class="breadcrumb-item active" aria-current="page">{{employeeData}}</li>
        </ol>
  </nav> -->

<div class="fixed">
    <div>
        <h4 >{{employeeData}}</h4>
    </div>
    <div *ngIf="employeeData === 'Employee Dashboard'">
        <img src="../../../assets/images/Employee Dashboard-1.png" alt="Innova_logo">
    </div>
    <div *ngIf="employeeData === 'Employee All Programmes Requests'">
        <img src="../../../assets/images/Employee-All-Programes-Requests5.png" alt="Innova_logo">
    </div>
    <div *ngIf="employeeData === 'Employee Career Path'">
        <img src="../../../assets/images/Employee-Career-Path-2.png" alt="Innova_logo">
    </div>
    <div *ngIf="employeeData === 'Program'">
        <img src="../../../assets/images/Program-3.png" alt="Innova_logo">
    </div>
    <div *ngIf="employeeData === 'Search Programs'">
        <img src="../../../assets/images/Search Programs-4.png" alt="Innova_logo">
    </div>
    <div *ngIf="employeeData === 'Employee Pending Programmes Request'">
        <img src="../../../assets/images/Employee-Pending-Programes-Request-6.png" alt="Innova_logo">
    </div>
    <div *ngIf="employeeData === 'Manager team Requests Pending'">
        <img src="../../../assets/images/Manager-Team-Requests-Pending-List-7.png" alt="Innova_logo">
    </div>
    <div *ngIf="employeeData === 'Proposal Repository Dashboard'">
        <img src="../../../assets/images/Proposal-Repository-Dashboard-8.jpg" alt="Innova_logo">
    </div>
    <div *ngIf="employeeData === 'Proposal Repository'">
        <img src="../../../assets/images/Proposal-Repository-Dashboard-9.jpg" alt="Innova_logo">
    </div>
</div>
